import * as authentication from '@wix/auto_sdk_identity_authentication';
import * as recovery from '@wix/auto_sdk_identity_recovery';
import * as verification from '@wix/auto_sdk_identity_verification';
import * as oauth from '@wix/auto_sdk_identity_oauth';
import * as signOnPolicy from '@wix/auto_sdk_identity_sign-on-policy';

export { authentication, recovery, verification, oauth, signOnPolicy };
